import { ApolloQueryResult } from '@apollo/client'
import { FC, useState } from 'react'
import CountdownLib from 'react-countdown'
import {
  julirea_product,
  julirea_productVariables,
} from '../../../../__generated__/julirea_product'
import { product, productVariables } from '../../../../__generated__/product'
import styles from './Countdown.module.scss'

interface ICountdown {
  discountActiveTo: number
  discountActive: boolean
  refetch: (
    variables?: Partial<productVariables | julirea_productVariables>,
  ) => Promise<ApolloQueryResult<product | julirea_product>>
}

const Countdown: FC<ICountdown> = ({
  discountActiveTo,
  discountActive,
  refetch,
}) => {
  const [completed, setCompleted] = useState(false)

  const renderer = ({ days, hours, minutes, seconds }) => {
    return (
      <h4 className={styles.time}>
        {days}
        <span className={styles.measure}>д.</span> {hours}
        <span className={styles.measure}>ч.</span> {minutes}
        <span className={styles.measure}>мин.</span> {seconds}
        <span className={styles.measure}>сек.</span>
      </h4>
    )
  }

  if (completed || !discountActive || !discountActiveTo) {
    return null
  }

  return (
    <div className={styles.wrapper}>
      <p className={styles.text}>АКЦИЯ ЗАВЕРШИТСЯ ЧЕРЕЗ</p>
      <CountdownLib
        date={discountActiveTo}
        onComplete={() => {
          setCompleted(true)
          refetch()
        }}
        renderer={renderer}
      />
    </div>
  )
}

export default Countdown
